import React from 'react';
import './Modal.css';

const ModalAddAssunto = ({ isOpen, onClose, onConfirm, novoAssunto, setNovoAssunto }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card white-theme"> 
        <h3>Adicionar Assunto</h3>
        <div className="modal-body">
          <label>Nome do assunto:</label>
          <input 
            type="text" 
            placeholder="Insira o novo assunto"
            value={novoAssunto}
            onChange={(e) => setNovoAssunto(e.target.value)}
            autoFocus
          />
        </div>
        <div className="modal-buttons">
          <button type="button" className="btn-modal-cancelar" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn-modal-adicionar" onClick={onConfirm}>Adicionar</button>
        </div>
      </div>
    </div>
  );
};

export default ModalAddAssunto;